import React from 'react';
import ButtonProps from '../../interfaces/ButtonProps';

const PlayVideoLibras: React.FC<ButtonProps> = ({color, className, onClickFunc}) => {
  return (
    <button className={className} onClick={onClickFunc}>
      <svg viewBox="0 0 87 87" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_40_1219)">
          <path d="M86.9997 43.5255C86.9759 67.5343 67.4928 87.0034 43.4946 87C19.4657 86.9931 -0.0683622 67.4288 -0.000311016 43.4302C0.0677401 19.401 19.5678 -0.047678 43.5456 -3.47235e-05C67.5643 0.0476085 87.0235 19.5371 86.9997 43.5255ZM78.2891 44.2844C78.6838 25.3087 63.6786 9.21894 44.3486 8.72208C25.3351 8.23544 9.20701 23.3145 8.72385 42.6679C8.24749 61.6742 23.331 77.798 42.695 78.271C61.6949 78.7373 77.7719 63.6514 78.2925 44.281L78.2891 44.2844Z" fill="white"/>
          <path d="M32.9573 43.5051C32.9573 39.5984 32.9505 35.6916 32.9641 31.7849C32.9641 31.1927 32.9913 30.587 33.1274 30.0153C33.614 27.936 35.2676 27.075 37.2615 27.8441C37.7855 28.0449 38.2925 28.3069 38.7824 28.5894C45.4719 32.4451 52.1579 36.3076 58.8405 40.1735C59.2794 40.4287 59.715 40.701 60.1131 41.0141C61.9164 42.4263 61.9232 44.5567 60.1233 45.9724C59.7014 46.3025 59.242 46.5883 58.7793 46.8572C52.1205 50.7095 45.4651 54.5652 38.7892 58.3868C38.0645 58.802 37.2615 59.1355 36.4517 59.3329C35.043 59.6766 33.7535 58.9415 33.3145 57.5531C33.09 56.8384 32.9811 56.0591 32.9743 55.307C32.9402 51.3731 32.9607 47.4357 32.9607 43.5017L32.9573 43.5051Z" fill="white"/>
          </g>
          <defs>
          <clipPath id="clip0_40_1219">
          <rect width="87" height="87" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </button>
  )
}

export default PlayVideoLibras